export default "__VITE_ASSET__8f051710__"